import { Methods, RestClient } from 'o2o_layout/lib/common/rest';
import { BIGDATA_CONSTANT } from '../../../../../common/constant';

const GetCheckUserAcceptedTermOfOrg = (orgId: string) => {
  let url = BIGDATA_CONSTANT.url.account + `api/accounts/users/current/accept-term/check?orgId=${orgId}`;
  var restClient = new RestClient(Methods.GET, url);
  return new Promise((resolve, reject) => {
    restClient.execute({}, {}).then(
      (response: any) => {
        const user: any = response.data;
        resolve(user);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export default GetCheckUserAcceptedTermOfOrg;
